import {API_ENTRYPOINT} from '@/config/entrypoint';

// Sdilena API vrstva pro pokemon domenu (stejny princip jako journeyApi.js).

function post(path, obj) {
    return {url: new URL(path, API_ENTRYPOINT), obj, method: 'POST'};
}

// vraci holou URL - konzumuje `pokemon/loadItems` (ocekava URL, ne {url,obj,method})
export function pokemonList(trainerId) {
    const url = new URL('api/pokemon-list', API_ENTRYPOINT);
    url.searchParams.set('trainer', trainerId);
    url.searchParams.set('order[inProfesorOak]', 'asc');
    url.searchParams.set('order[id]', 'asc');
    url.searchParams.set('stolen', false);
    url.searchParams.set('page', 1);
    url.searchParams.set('itemsPerPage', 1000);
    return url;
}

export function leavePokemon(pokemonId) {
    return post('api/leave-pokemon', {pokemonId});
}

// Vsichni trenerovi pokemoni (bez ohledu na inProfesorOak) - konzumuje
// `pokemon/fetchObject` (GET vrati syrova data, NEPRESUJE do sdileneho
// `pokemon/items`). DULEZITE: nikdy nepouzivat s `pokemon/loadItems` pro
// tohle sirsi dotazovani - `loadItems` by prepsal SDILENY `pokemon/items`
// seznam, ktery TeamBottomSheet.vue plni uzsim filtrem (aktivni tym max 6).
// Pouzito v CityHealDialog.vue (`poke-center` leci VSECHNY pokemony, ne jen
// aktivni tym) a OakTable.vue (Oak spravuje vsechny pokemony).
export function pokemonListAll(trainerId) {
    const url = new URL('api/pokemon-list', API_ENTRYPOINT);
    url.searchParams.set('trainer', trainerId);
    url.searchParams.set('order[inProfesorOak]', 'asc');
    url.searchParams.set('order[id]', 'asc');
    url.searchParams.set('stolen', false);
    url.searchParams.set('itemsPerPage', 1000);
    return {url, obj: null, method: 'GET'};
}

// Strankovana varianta pro OakTable.vue (hrac s desitkami pokemonu jinak
// natahne uplne vsechno najednou, i kdyz tabulka zobrazuje jen 10 radku).
// `sortBy: 'level'` mapuje na `pokemonExperience.exp` - Level je cistě
// dopočítaná hodnota (Pokemon::getLevel()), na serveru neni sloupec, ktery
// by šlo radit primo, ale je to monotonni funkce exp. Razeni podle "name"
// jde přes vlastni PokemonNameOrderExtension.php (COALESCE s pokemonType.name
// pro nepojmenovane pokemony), ne primo skrz OrderFilter.
export function pokemonListPaged(trainerId, {page = 1, itemsPerPage = 10, sortBy = null, sortDesc = false} = {}) {
    const url = new URL('api/pokemon-list', API_ENTRYPOINT);
    url.searchParams.set('trainer', trainerId);
    url.searchParams.set('stolen', false);
    url.searchParams.set('page', page);
    url.searchParams.set('itemsPerPage', itemsPerPage);
    const orderField = sortBy === 'level' ? 'pokemonExperience.exp' : sortBy;
    if (orderField) {
        url.searchParams.set(`order[${orderField}]`, sortDesc ? 'desc' : 'asc');
    } else {
        url.searchParams.set('order[inProfesorOak]', 'asc');
        url.searchParams.set('order[id]', 'asc');
    }
    return {url, obj: null, method: 'GET'};
}

// Lehky dotaz jen na pocet pokemonu v AKTIVNIM tymu (inProfesorOak=false).
// `itemsPerPage=1` drzi payload minimalni, potrebne je jen `totalItems`
// v obalce kolekce.
export function pokemonActiveTeamCount(trainerId) {
    const url = new URL('api/pokemon-list', API_ENTRYPOINT);
    url.searchParams.set('trainer', trainerId);
    url.searchParams.set('stolen', false);
    url.searchParams.set('inProfesorOak', false);
    url.searchParams.set('itemsPerPage', 1);
    return {url, obj: null, method: 'GET'};
}
